function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E4E7E7",
  d: "M12,16h104v100H12V16z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  fill: "#CDCFCF",
  height: 5.1,
  width: 104,
  x: 12,
  y: 42.9
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E4E7E7",
  d: "M128,33l-10.2-10H10.1L0,33h0v6.7C0,41.5,1.5,43,3.4,43h121.3c1.9,0,3.4-1.5,3.4-3.3L128,33L128,33z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#CDCFCF",
  points: "127.7,32.7 117.8,23 10.1,23 0.3,32.7 "
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#CCD0D2",
  d: "M18.8,9h90.3l6.9,7H12L18.8,9z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#2EA9D3",
  d: "M19,110h23V43H19V110z M49,116h30V43H49V116z M86,43v67h23V43H86z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#2EA9D3",
  d: "M19,110h23V43H19V110z M49,116h30V43H49V116z M86,43v67h23V43H86z"
})));

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3DB39E",
  d: "M58.3,59h11.5c1.8,0,3.3,1.5,3.3,3.4v5.1c0,1.9-1.5,3.4-3.3,3.4H58.3c-1.8,0-3.3-1.5-3.3-3.4v-5.1  C55,60.5,56.5,59,58.3,59z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E4E7E7",
  d: "M69.7,62c0.1,0,0.3,0.2,0.3,0.4v5.1c0,0.3-0.2,0.4-0.3,0.4H58.3c-0.1,0-0.3-0.2-0.3-0.4v-5.1  c0-0.3,0.2-0.4,0.3-0.4H69.7 M69.7,59H58.3c-1.8,0-3.3,1.5-3.3,3.4v5.1c0,1.9,1.5,3.4,3.3,3.4h11.5c1.8,0,3.3-1.5,3.3-3.4v-5.1  C73,60.5,71.5,59,69.7,59L69.7,59z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  fill: "#2998BD",
  points: "42,85 33,85 33,74 19,74 19,110 42,110  "
}), React.createElement("rect", {
  fill: "#2998BD",
  height: 31,
  width: 12,
  x: 49,
  y: 85
}), React.createElement("rect", {
  fill: "#2998BD",
  height: 35,
  width: 23,
  x: 86,
  y: 75
}), React.createElement("rect", {
  fill: "#2998BD",
  height: 24,
  width: 8,
  x: 71,
  y: 92
}));

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3DB39E",
  d: "M100.5,104.2c1.6,0,3.1,0.5,4.4,1.4c0.9-5.5,5.7-9.6,11.5-9.6c6.4,0,11.7,5.1,11.7,11.5  c0,6.4-5.2,11.5-11.7,11.5c-0.5,0-15.2,0-15.8,0c-4.1,0-7.5-3.3-7.5-7.4C93,107.5,96.4,104.2,100.5,104.2z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3DB39E",
  d: "M27.5,104.2c-1.6,0-3.1,0.5-4.4,1.4c-0.9-5.5-5.7-9.6-11.5-9.6C5.2,96,0,101.2,0,107.5  c0,6.4,5.2,11.5,11.7,11.5c0.5,0,15.2,0,15.8,0c4.1,0,7.5-3.3,7.5-7.4C35,107.5,31.6,104.2,27.5,104.2z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#37A18E",
  d: "M27.5,116c-0.6,0-15.4,0-15.8,0c-5.9,0-10.8-4.4-11.5-10C0,106.5,0,107,0,107.5c0,6.4,5.2,11.5,11.7,11.5  c0.5,0,15.2,0,15.8,0c4.1,0,7.5-3.3,7.5-7.4c0-0.5-0.1-1-0.2-1.5C34.1,113.5,31.1,116,27.5,116z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#37A18E",
  d: "M116.3,116c-0.5,0-15.2,0-15.8,0c-3.6,0-6.6-2.5-7.3-5.9c-0.1,0.5-0.2,1-0.2,1.5c0,4.1,3.4,7.4,7.5,7.4  c0.6,0,15.4,0,15.8,0c6.4,0,11.7-5.1,11.7-11.5c0-0.5,0-1-0.1-1.5C127.1,111.6,122.3,116,116.3,116z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("rect", {
  fill: "#2998BD",
  height: 4.9,
  width: 23,
  x: 86,
  y: 43
}), React.createElement("rect", {
  fill: "#2998BD",
  height: 4.9,
  width: 23,
  x: 19,
  y: 43
}), React.createElement("rect", {
  fill: "#2998BD",
  height: 4.9,
  width: 30,
  x: 49,
  y: 43
}));

var _ref15 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#E2574C",
  d: "M117.8,23H112l9,10v10h3.6c1.9,0,3.4-1.5,3.4-3.3V33l-0.1-0.1L117.8,23z"
}), React.createElement("polygon", {
  fill: "#E2574C",
  points: "33.9,32.7 37.9,23 32.1,23 27,32.7 27,43 33.9,43  "
}), React.createElement("polygon", {
  fill: "#E2574C",
  points: "13,43 19.9,43 19.9,33 27,23 20.3,23 13,33  "
}), React.createElement("polygon", {
  fill: "#E2574C",
  points: "61,32.9 62,23 55,23 54.1,32.8 54.1,43 61,43  "
}), React.createElement("polygon", {
  fill: "#E2574C",
  points: "47.9,42.9 47.9,32.7 50,23 43.5,23 41,32.7 41,42.9  "
}), React.createElement("polygon", {
  fill: "#E2574C",
  points: "101,43 101,32.7 95.9,23.1 90.1,23.1 94,32.7 94,43  "
}), React.createElement("polygon", {
  fill: "#E2574C",
  points: "115,43 115,33 107.7,23 101,23 108.1,33 108.1,43  "
}), React.createElement("path", {
  fill: "#E2574C",
  d: "M3.4,43H7V33l9-10h-5.9L0,33h0l0,0v6.6C0,41.5,1.5,43,3.4,43z"
}), React.createElement("polygon", {
  fill: "#E2574C",
  points: "73.9,43 73.9,32.9 73,23 66,23 67,32.9 67,43  "
}), React.createElement("polygon", {
  fill: "#E2574C",
  points: "80.1,32.7 80.1,42.9 87,42.9 87,32.7 84.5,23 78,23  "
}));

var _ref16 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  fill: "#CB4E44",
  points: "95.9,23.1 90.1,23.1 94,32.7 100.9,32.7  "
}), React.createElement("polygon", {
  fill: "#CB4E44",
  points: "73,23 66,23 67,32.7 73.9,32.7  "
}), React.createElement("polygon", {
  fill: "#CB4E44",
  points: "117.8,23 112,23 120.7,32.7 127.7,32.7  "
}), React.createElement("polygon", {
  fill: "#CB4E44",
  points: "107.7,23 101,23 107.8,32.7 114.7,32.7  "
}), React.createElement("polygon", {
  fill: "#CB4E44",
  points: "84.4,23 78,23 80.1,32.7 87,32.7  "
}), React.createElement("polygon", {
  fill: "#CB4E44",
  points: "41,32.7 47.9,32.7 50,23 43.5,23  "
}), React.createElement("polygon", {
  fill: "#CB4E44",
  points: "27,23 20.3,23 13.2,32.7 20.1,32.7  "
}), React.createElement("polygon", {
  fill: "#CB4E44",
  points: "54.1,32.7 61,32.7 62,23 55,23  "
}), React.createElement("polygon", {
  fill: "#CB4E44",
  points: "0.3,32.7 7.3,32.7 16,23 10.1,23  "
}), React.createElement("polygon", {
  fill: "#CB4E44",
  points: "27,32.7 33.9,32.7 37.9,23 32.1,23  "
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 128,
    height: 128,
    id: "\u0421\u043B\u043E\u0439_1",
    style: {
      "enableBackground": "new 0 0 128 128"
    },
    version: 1.1,
    viewBox: "0 0 128 128",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/ic-store.15628625.svg";
export { SvgComponent as ReactComponent };